/**
 * Prism.js bootstrap for the Integration Guides.
 *
 * Two things MUST happen before any Prism language component file loads:
 *
 *   1. `window.Prism` must be assigned. Prism's language component files (e.g.
 *      `prismjs/components/prism-csharp.js`) register themselves by reading a global
 *      `Prism` variable at module-evaluation time. In an ES-module / bundler context
 *      that global is not set automatically - the language registrations silently fail
 *      and highlighting never happens.
 *
 *   2. `Prism.manual = true` must be set. By default Prism registers a
 *      DOMContentLoaded (or rAF) callback that highlights every
 *      `<pre><code class="language-X">` on the page. That callback fires on its own
 *      schedule, which can race with our language-dependency imports and throw
 *      "Cannot read properties of undefined (reading 'tokenizePlaceholders')" errors
 *      when a grammar like PHP runs before `markup-templating` has loaded. We
 *      highlight manually inside GuideCodeTabs, so this auto-scan is pure downside.
 *
 * This file is imported FIRST by GuideCodeTabs.vue, before any `prismjs/components/*`
 * imports. Because ES module bodies execute in dependency-declaration order, the side
 * effects here run before the language components are evaluated.
 *
 * Do not merge the language imports into this file: they must appear AFTER this
 * module has run from the consuming component's perspective, which means they must
 * live in that component's imports, not here.
 */
import Prism from 'prismjs';

if (typeof window !== 'undefined' && !window.Prism) {
    window.Prism = Prism;
}

// Disable Prism's automatic highlight-all-on-page-load behavior. We always call
// Prism.highlightElement explicitly from GuideCodeTabs. Leaving auto on creates a
// race with language-component imports (especially PHP, which depends on
// markup-templating) and shows up as console errors on every page load.
Prism.manual = true;

export default Prism;
